// Logo oficial LALA ELITE — kit de marca V1 (Feb 2026).
// Ahora usa el logo oficial "Lala Elite" (estrella de leche + palabra ELITE) en badge circular azul.
// Variantes:
//   palette="lala" · palette="blanco" · palette="azul" · palette="negativo" → todas apuntan al mismo asset oficial Elite
// Mantiene el nombre del componente para no romper imports existentes.

export default function Mariposa({ size = 140, animated = true, palette = "lala", className = "" }) {
  const animClass = animated ? "lala-breath" : "";

  // Pick smallest asset that won't pixelate
  let suffix = "_sm";
  if (size >= 400) suffix = "_lg";
  else if (size >= 180) suffix = "_md";
  else if (size < 80) suffix = "_xs";

  const src = `/brand/lala_elite_badge${suffix}.png`;

  return (
    <span
      data-testid="lala-logo"
      className={`lala-logo ${animClass} ${className}`}
      style={{ width: size, height: size, display: "inline-block", lineHeight: 0 }}
      aria-label="Lala Elite"
    >
      <img
        src={src}
        alt="Lala Elite"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain", display: "block" }}
        draggable={false}
      />
    </span>
  );
}
